import React, { useState } from 'react'
import Button from '../atoms/Button'
import Icon from '../atoms/Icon'
import './CopyButton.css'

const CopyButton = ({ 
  text, 
  variant = 'secondary', 
  size = 'small', 
  className = '',
  ...props 
}) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy text: ', err)
    }
  }

  const classes = [
    'copy-button',
    copied && 'copy-button-copied',
    className
  ].filter(Boolean).join(' ')

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleCopy}
      className={classes}
      {...props}
    >
      <Icon size="small">
        {copied ? '✓' : '📋'}
      </Icon>
      {copied ? 'Copied!' : 'Copy'}
    </Button>
  )
}

export default CopyButton
